import React, { useState, useEffect } from 'react';
import useModalClose from '../../hooks/useModalClose';
import { updateAddress } from '../../services/addressService';

const UpdateAddressModal = ({ isOpen, onClose, address, onSuccess }) => {
  const [formData, setFormData] = useState({
    fullAdres: '',
    ilce: '',
    mah: '',
    sokak: '',
    apartman: '',
    kapiNo: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (address) {
      setFormData({
        fullAdres: address.fullAdres || '',
        ilce: address.ilce || '',
        mah: address.mah || '',
        sokak: address.sokak || '',
        apartman: address.apartman || '',
        kapiNo: address.kapiNo || '',
      });
    }
  }, [address]);

  const resetState = () => {
    setIsLoading(false);
    setError(null);
  };

  useEffect(() => {
    if (!isOpen) {
      resetState();
    }
  }, [isOpen]);

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    if (!formData.fullAdres || !formData.ilce || !formData.mah || !formData.sokak || !formData.kapiNo) {
      setError('Lütfen tüm alanları doldurunuz.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        FullAdres: formData.fullAdres,
        Ilce: formData.ilce,
        Mah: formData.mah,
        Sokak: formData.sokak,
        Apartman: formData.apartman,
        KapiNo: formData.kapiNo,
        Id: address.id
      };

      await updateAddress(payload);
      onSuccess();
      handleClose();
    } catch (error) {
      setError('Adres güncellenirken bir hata oluştu.');
      console.error('Update address error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Add modal closing behaviors
  useModalClose(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content update-address-modal">
        <div className="modal-header">
          <h3>Adres Bilgilerini Güncelle</h3>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit} className="update-address-form">
            <div className="form-group">
              <label htmlFor="fullAdres">Tam Adres</label>
              <input
                type="text"
                id="fullAdres"
                name="fullAdres"
                value={formData.fullAdres}
                onChange={handleInputChange}
                placeholder="Tam Adres"
              />
            </div>
            <div className="form-group">
              <label htmlFor="ilce">İlçe</label>
              <input
                type="text"
                id="ilce"
                name="ilce"
                value={formData.ilce}
                onChange={handleInputChange}
                placeholder="İlçe"
              />
            </div>
            <div className="form-group">
              <label htmlFor="mah">Mahalle</label>
              <input
                type="text"
                id="mah"
                name="mah"
                value={formData.mah}
                onChange={handleInputChange}
                placeholder="Mahalle"
              />
            </div>
            <div className="form-group">
              <label htmlFor="sokak">Sokak</label>
              <input
                type="text"
                id="sokak"
                name="sokak"
                value={formData.sokak}
                onChange={handleInputChange}
                placeholder="Sokak"
              />
            </div>
            <div className="form-group">
              <label htmlFor="apartman">Apartman</label>
              <input
                type="text"
                id="apartman"
                name="apartman"
                value={formData.apartman}
                onChange={handleInputChange}
                placeholder="Apartman"
              />
            </div>
            <div className="form-group">
              <label htmlFor="kapiNo">Kapı No</label>
              <input
                type="text"
                id="kapiNo"
                name="kapiNo"
                value={formData.kapiNo}
                onChange={handleInputChange}
                placeholder="Kapı No"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="form-actions">
              <button 
                type="button" 
                onClick={handleClose} 
                className="cancel-button"
                disabled={isLoading}
              >
                İptal
              </button>
              <button 
                type="submit" 
                className="submit-button"
                disabled={isLoading}
              >
                {isLoading ? 'Güncelleniyor...' : 'Güncelle'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateAddressModal;
